<div class="conversation-input-container">
  @if (shouldShowFilters) {
    <app-conversation-filters
      [visible]="filtersAreOpened"
      [anchor]="filtersAnchor"
      [bot]="bot"
      (filterChange)="handleFilterChange($event)"
    ></app-conversation-filters>
  }
  <div>
    <form class="conversation-input-form" (ngSubmit)="submit()" [formGroup]="messagesForm">
      <div #filtersAnchor #promptHintsAnchor class="message">
        <div [class.is-focussed]="isInputFocused" class="message--content">
          @if (files.length > 0 || selectedSources.length > 0) {
            <div class="message--attachments">
              @for (file of files; track file; let i = $index) {
                <app-input-file-preview (removeAt)="removeFile(i)" [file]="file" [itemFormIndex]="i"></app-input-file-preview>
              }
              @for (source of selectedSources; track source._id) {
                <div class="source-item">
                  <span class="source-name">{{ source.name }}</span>
                  <mat-icon (click)="removeSource(source)">close</mat-icon>
                </div>
              }
            </div>
          }
          <div class="message--input padding">
            <div class="w-full" (dragenter)="handleDragEnter($event)" (dragover)="handleDragOver($event)" (dragleave)="handleDragLeave($event)" (drop)="handleDrop($event)" [class.drag-over]="isDragging">
              <textarea (blur)="onInputBlur()" (focus)="onInputFocus()" (keydown)="onKeyDown($event)" [hidden]="isDragging" [placeholder]="placeholder" autosize formControlName="message" class="message-input" [minRows]="1" [maxRows]="6"></textarea>
              @if (areFilesAllowedToAttach()) {
                <div [hidden]="!isDragging" class="dnd-container">
                  <app-conversation-dnd (filesDropped)="handleFileInput($event)"></app-conversation-dnd>
                </div>
              }
            </div>
            <div class="message--actions">
              <div class="message--action-buttons">
                @if (shouldShowFilters) {
                  <app-custom-button icon="tune" tooltip="Toggle filters" [active]="filtersAreOpened" (buttonClick)="toggleFilters()"></app-custom-button>
                }
                <!-- Prompt hints menu button: shown for specific bot conversations -->
                @if (hasPromptHints && bot) {
                  <app-prompt-hints-menu (hintSelected)="updateMessage($event)" [promptHints]="getEffectivePromptHints()"></app-prompt-hints-menu>
                }
                @if (hasAssistantMessages() && isTalkingAvatarActive()) {
                  <app-custom-button icon="record_voice_over" tooltip="Read conversation aloud" (buttonClick)="readConversationAloud()"></app-custom-button>
                }
                <app-custom-button icon="source" tooltip="Add from sources" (buttonClick)="openSourceSearch()"></app-custom-button>
                <app-custom-button icon="attach_file" tooltip="Attach up to 5 files" (buttonClick)="fileInput.click()"></app-custom-button>

                <!-- Keywords quick actions -->
                @if (shouldShowKeywords) {
                  <div class="keywords-container">
                    @for (keyword of getKeywordsToDisplay(); track keyword) {
                      <div class="keyword-chip" [class.active]="isKeywordActive(keyword)" (click)="onKeywordClick(keyword)" [title]="'Click to toggle keyword: ' + keyword.displayText">
                        <mat-icon class="keyword-icon">{{ isKeywordActive(keyword) ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                        <span>{{ keyword.displayText }}</span>
                      </div>
                    }
                  </div>
                }
              </div>
              <!-- Avatar talking disclaimer -->
              @if (showAvatarDisclaimer()) {
                <div class="avatar-disclaimer">
                  <mat-icon class="disclaimer-icon">info</mat-icon>
                  <span class="disclaimer-text">Avatar is talking - please wait before saving files</span>
                </div>
              }
              <div class="message--send-area">
                <!-- Always show talking avatar toggle -->
                <app-talking-avatar-toggle [bot]="bot"></app-talking-avatar-toggle>
                <app-speech-recognition (finished)="setPlaceholder()" (started)="setPlaceholder('Listening...')" (transcription)="updateMessage($event)" [hidden]="!(messagesForm.get('message')?.value === '' && !isWriting)" [language]="'en-US'" class="speech-recognition-btn"></app-speech-recognition>
                @if (messagesForm.valid && !isWriting) {
                  <app-custom-button icon="send" tooltip="Send message" [active]="true" (buttonClick)="submit()"></app-custom-button>
                }
                @if (isWriting) {
                  <app-custom-button icon="stop" tooltip="Stop generation" (buttonClick)="writingAbort.emit()"></app-custom-button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Prompt hints dropdown: shown for dashboard (no specific bot) -->
      @if (shouldShowPromptHintsDropdown && !bot) {
        <app-prompt-hints-dropdown [anchor]="promptHintsAnchor" [promptHints]="getEffectivePromptHints()" [isVisible]="isInputFocused && hasPromptHints" [selectedIndex]="selectedHintIndex" (hintSelected)="selectPromptHint($event)" (selectedIndexChange)="selectedHintIndex = $event"></app-prompt-hints-dropdown>
      }
      <input #fileInput (change)="onFileSelected($event)" hidden multiple type="file" />
    </form>
  </div>
</div>
